import "./styles.scss";

import { useState, createRef } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";

import { bulkInsert } from "../../../store/middleware";

import { User } from "../companies/styles";

function StudentBulkForm({ addNewStudent, setShowAddStudentBulkForm }) {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  let fileUploader = createRef();
  const { contract } = useSelector((state) => state.b2bContractsReducer);

  const [generalState, setGeneralState] = useState({
    filename: "",
    file: "",
    errors: [
      { line: 1, messages: [] },
      { line: 2, messages: [] },
    ],
    validObjects: [],
    done: false,
    loading: false,
  });

  const addBulkStudent = () => {
    setGeneralState({
      filename: "",
      file: "",
      errors: [
        { line: 1, messages: [] },
        { line: 2, messages: [] },
      ],
      validObjects: [],
      done: false,
      loading: false,
    });
  };

  const handleUpload = (e) => {
    const file = e.target.files[0];
    if (file) {
      setGeneralState({ ...generalState, file: file, filename: file.name });
    }
  };

  const handleBack = () => {
    setShowAddStudentBulkForm(false);
  };

  const handleClick = () => {
    fileUploader.click();
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const { file } = generalState;
    try {
      if (!file) {
        return;
      }
      const formData = new FormData();
      formData.append("file", file);
      this.setState({ loading: true });
      const res = await dispatch(bulkInsert(contract.id, formData));
      const items = res.data.result.items[0];
      const { errors, validObjects } = items;
      setGeneralState({
        ...generalState,
        loading: false,
        errors,
        validObjects,
        done: errors.length > 0 || validObjects.length > 0,
      });
    } catch (err) {
      console.log("Failed to bulk add student.", err);
    }
  };

  const { done, validObjects, errors } = generalState;
  return (
    <User>
      <div className="bigBox bigBoxForm" style={{ paddingLeft: "100px" }}>
        <h2>
          {t("BULK_ADD_NEW_STUDENT")} {done ? <strong>&#9679; {t("BULK_RESULTS")}</strong> : null}
        </h2>

        <div className={done ? "hide" : "form-upload"}>
          <div className="formulario">
            <div className="bulk">
              <h3>Add multiple students to this contract. Select your data file and upload it.</h3>
              <button type="button" onClick={handleClick} className="btn-upload">
                Select file
              </button>
              <input
                ref={fileUploader}
                type="file"
                className="hide"
                onChange={handleUpload}
                accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
              />
              <div className={generalState.filename ? "filename" : "hide"}>
                <b>File:</b> {generalState.filename}
              </div>
            </div>
          </div>
        </div>

        <div className={!done ? "hide" : "bulk-results"}>
          <div className="formulario">
            {validObjects && validObjects.length > 0 ? (
              <div className="success">
                <h4>{validObjects.length} students sucessfully added!</h4>
                <button type="button" onClick={() => setShowAddStudentBulkForm(false)} className="btn">
                  {t("BTN_VIEW")}
                </button>
              </div>
            ) : null}

            {errors && errors.length > 0 ? (
              <div className="errors">
                <h4>{`${errors.length} students couldn't be added :(`}</h4>
                <div className="list">
                  {errors.map((error) => {
                    return (
                      <div key={JSON.stringify(error)}>
                        <h4>&#9679; Line {error.line}</h4>
                        <ul>
                          {error.messages.map((e) => {
                            return <li key={JSON.stringify(e)}>{e}</li>;
                          })}
                        </ul>
                      </div>
                    );
                  })}
                </div>
              </div>
            ) : null}
          </div>
          <div className="form-buttons">
            <button
              type="button"
              className="btn-save"
              style={{ width: "200px", marginRight: "20px" }}
              onClick={addBulkStudent}
            >
              <i className="fa fa-plus" aria-hidden="true"></i> {t("BULK_ADD_STUDENT")}
            </button>
            <button type="button" className="btn-save" style={{ width: "200px" }} onClick={addNewStudent}>
              <i className="fa fa-plus" aria-hidden="true"></i> {t("ADD_NEW_STUDENT")}
            </button>
          </div>
        </div>
      </div>

      <div className="form-buttons">
        <button type="button" className="btn-back" onClick={handleBack}>
          <i className="fa fa-angle-left" aria-hidden="true"></i>
          {t("BTN_BACK")}
        </button>
        <button type="submit" className="btn-save" onClick={handleSubmit}>
          {t("UPLOAD")}
        </button>
      </div>
    </User>
  );
}

export default StudentBulkForm;
